//Custom components
import StatCard from '../../../UI/Card/StatCard';

const TotalApplicationsWidget = ({ count }: { count: number }) => {
  return <StatCard title='Total Submissions' stat={count} />;
};

export default TotalApplicationsWidget;
